export const iconFontAwesomeMapsVestPatches = (
	<i className="fa-solid fa-vest-patches"></i>
);
